export default __webpack_public_path__ + "535b36b75bb3280f14b44c7d009822c8.wav";